import React, { useEffect } from "react";
import "@/App.css";
import "@/lib/analytics";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyContact from "@/components/StickyContact";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";

import Home from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import ServicePage from "@/pages/ServicePage";
import AboutPage from "@/pages/About";
import BlogPage from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import PrivacyPage from "@/pages/Privacy";
import ContactPage from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let in-page anchors handle themselves
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-navy focus:text-white focus:px-3 focus:py-2 focus:rounded">Skip to main content</a>
      {!isAdmin && <Header />}
      <div id="main">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        {/* Legacy /journal URLs redirect to /blog */}
        <Route path="/journal" element={<Navigate to="/blog" replace />} />
        <Route path="/journal/:slug" element={<RedirectJournalToBlog />} />
        <Route path="/for-families-abroad" element={<FamiliesAbroadRedirect />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Home />} />
      </Routes>
      </div>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyContact />}
    </>
  );
}

function RedirectJournalToBlog() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/journal\//, "");
  return <Navigate to={`/blog/${slug}`} replace />;
}

// For now, "For Families Abroad" is a homepage section (anchor). Dedicated page comes in Phase 2.
function FamiliesAbroadRedirect() {
  return <Navigate to="/#for-families-abroad" replace />;
}

function App() {
  return (
    <div className="App bg-bone text-ink">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <ScrollToTop />
            <Shell />
            <Toaster position="top-center" richColors closeButton toastOptions={{ style: { fontFamily: "Plus Jakarta Sans, sans-serif" } }} />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
